import { Modal } from "@mgdx/ui/components/Modal";
import { useMemo } from "react";

import { useCurrentUser } from "../../hooks/useCurrentUser";
import { useDeleteUser } from "../../hooks/useDeleteUser";
import { useIsOIDCCredential } from "../../hooks/useIsOIDCCredential";
import {
  AgreementNewTermsWithdrawView,
  AgreementNewTermsWithdrawViewProps,
} from "../../views/AgreementNewTermsWithdrawView";

export const AgreementNewTermsWithdrawModal = ({
  onClickShowReason,
}: Omit<AgreementNewTermsWithdrawViewProps, "deleteUser">) => {
  const currentUser = useCurrentUser();
  const isOIDCCredential = useIsOIDCCredential({ providerId: "oidc.satudora" });
  const linkType = useMemo(() => {
    if (currentUser.isLiffLogined) return "liff";
    if (isOIDCCredential) return "oidc";

    return "";
  }, [currentUser.isLiffLogined, isOIDCCredential]);
  const deleteUser = useDeleteUser({ linkType });

  return (
    <Modal open={true} size="full">
      <AgreementNewTermsWithdrawView deleteUser={deleteUser} onClickShowReason={onClickShowReason} />
    </Modal>
  );
};
